
import React, {useState, useEffect} from 'react';
import {CircularProgress, Dialog, IconButton, Button} from '@material-ui/core';
import useStyles from './styles';
import CloseIcon from '@material-ui/icons/Close';
// import Button from '../../../components/Base/Button';
import LabelInput from 'components/Base/LabelInput';
import LabelTextArea from 'components/Base/LabelTextArea';
import { createGroup } from 'actions/customer';
import { useDispatch, useSelector } from 'react-redux';
import UploadMedia from 'components/Base/UploadMedia';

const CreateGroup = (props: any) => {
    const {open} = props;
    const styles = useStyles();
    const [groupName, setGroupName] = useState('');
    const [groupDescription, setGroupDescription] = useState('');
    const dispatch = useDispatch();
    const [image, setImage] = useState<any>(null);
    const { addCustomer, loadCreate } = useSelector((state: any) => state.customers);
    const [error, setError] = useState({name: false, file: false});

    const validate  = () => {
      let rs = false;
      let errorVar = {name: false, file: false}
      if(groupName.length === 0) {
        rs = true;
        errorVar.name = true;
      }
      if(!image){
        rs = true;
        errorVar.file = true
      }
      setError(errorVar);
      return rs;
    }

    const handleCreate = () => {
      if(validate()) return;
      dispatch(createGroup(Object.assign({name: groupName, description: groupDescription, app_id: 1}, image && {logo: image})));
    }

    useEffect(() => {
      if(addCustomer){
        handleCloseModal(true);
      }
    }, [addCustomer]);

    const handleCloseModal = (loadList?: any) => {
      const {onCloseModal} = props;
      setGroupName('');
      setGroupDescription('');
      setImage(null);
      setError({name: false, file: false});
      onCloseModal(loadList);
    }

    const onChangeGroupDescription =  (event: any) => {
      setGroupDescription(event?.target?.value);
    }

    const onChangeGroupName = (event: any) => {
      if(!event?.target?.value){setError(Object.assign(error, {name: true}))}else{setError(Object.assign(error, {name: false}))}
      setGroupName(event?.target?.value);
    }

    const onChangeLogo = (image: any, thumbnailImage: any) => {
      if(!image){setError(Object.assign(error, {file: true}))}else{setError(Object.assign(error, {file: false}))}
      setImage(image);
    }

    return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      fullWidth={true}
      maxWidth={'lg'}
      classes={{paper: styles.paperModal}}
      PaperProps={{
        style: { boxShadow: 'none', width: '80vw' },
      }}
    >
      <div className={styles.contentModal}>
        <div className={styles.titleModal}>Create A Group</div>
        <p className={styles.subtitleModal}>Enter in the below info to create a new organization.</p>
        <IconButton className={styles.closeButton} edge="end" color="inherit" onClick={() => handleCloseModal()} aria-label="close">
          <CloseIcon />
        </IconButton>
        <div className={styles.contentBodyModal}>
          <div className={styles.contentCenter}>
          <div className={styles.contentLeft}>
            <LabelInput
              value={groupName}
              onChange={onChangeGroupName}
              placeholder=''
              label='Group Name'
              customClass={styles.labelInputGroupName}
              errors={error?.name}
              maxLength={50}
            />
            <LabelTextArea
              value={groupDescription}
              onChange={onChangeGroupDescription}
              placeholder=''
              label='Group Description '
              optional={true}
              customClass={styles.labelInputGroupDescription}
              maxLength={255}
            />
            </div>
            <div className={styles.contentRight}>
              <UploadMedia
                label='Group Image or Logo'
                placeholder={'Click to\nUPLOAD IMAGE'}
                onChangeImage={onChangeLogo}
                errors={error?.file}
               />
            </div>
          </div>
          </div>
      </div>
      <div className={styles.modalFooter}>
        <Button variant='text' onClick={handleCloseModal} style={{textTransform: 'capitalize', fontWeight: 400}}>
          <span>Cancel</span>
        </Button>
        <div className={`${styles.btnCreateNew} d-inline-block`}>
          <Button
            variant='contained'
            onClick={handleCreate}
            disabled={loadCreate}
          >
            <span>Create</span>
            {loadCreate && (
              <span className={styles.iconLoading}>
                <CircularProgress size={16} />
              </span>
            )}
          </Button>
        </div>
      </div>  
    </Dialog>
    )
}
export default CreateGroup;